'use client';

import React from 'react';
import { Box, HStack, VStack, Text, Button } from '@skin-seoul/design-system';
import Image from 'next/image';
import { useSafeRouter } from '@/hooks';
import { CLASSNAME, useProductService, useRegionCurrency } from '@skin-seoul/service';
import { useParams } from 'next/navigation';
const BrandSection = () => {
  const {
    useGetProductsDetail
  } = useProductService();
  const {
    currency
  } = useRegionCurrency();
  const params = useParams();
  const {
    data: {
      relatedCollections
    }
  } = useGetProductsDetail({
    slug: params.slug as string,
    currency
  });
  const router = useSafeRouter();
  const handleBrandClick = () => {
    router.push(`/brand/${relatedCollections?.brand?.slug ?? ''}`);
  };
  return <Box background="white" position="relative" width="100%" data-sentry-element="Box" data-sentry-component="BrandSection" data-sentry-source-file="BrandSection.tsx">
      <Box marginX={{
      base: 4,
      tablet: 0
    }} position="absolute" top={0} left={0} right={0} height="0.5px" background="neutral.100" pointerEvents="none" data-sentry-element="Box" data-sentry-source-file="BrandSection.tsx" />

      <HStack alignItems="center" justifyContent="space-between" paddingX={{
      base: 4,
      tablet: 0
    }} paddingY={5} width="100%" data-sentry-element="HStack" data-sentry-source-file="BrandSection.tsx">
        {/* Brand Info */}
        <HStack gap={2} alignItems="center" justifyContent="flex-start" flexShrink={0} cursor="pointer" onClick={handleBrandClick} _hover={{
        opacity: 0.8
      }} transition="opacity 0.2s" data-sentry-element="HStack" data-sentry-source-file="BrandSection.tsx">
          {/* Brand Logo */}
          <Box background="white" borderRadius="140px" width={{
          base: '44px',
          tablet: '56px'
        }} height={{
          base: '44px',
          tablet: '56px'
        }} position="relative" flexShrink={0} border="1px solid" borderColor="neutral.200" overflow="hidden" display="flex" alignItems="center" justifyContent="center" data-sentry-element="Box" data-sentry-source-file="BrandSection.tsx">
            {relatedCollections?.brand?.brandImageUrl ? <Image objectFit="contain" src={relatedCollections.brand.brandImageUrl} alt={relatedCollections.brand.name ?? ''} fill /> : <Text textStyle={{
            base: 'label.xsmall',
            tablet: 'label.small'
          }} fontWeight="normal" color="generic.100" textAlign="center" paddingX={1} wordBreak="break-word" className={CLASSNAME.NOT_TRANSLATE}>
                {relatedCollections?.brand?.name ?? ''}
              </Text>}
          </Box>

          {/* Brand Text */}
          <VStack gap={{
          base: 1,
          tablet: 2
        }} alignItems="flex-start" justifyContent="flex-start" flexShrink={0} data-sentry-element="VStack" data-sentry-source-file="BrandSection.tsx">
            <Text textStyle={{
            base: 'label.medium',
            tablet: 'label.large'
          }} fontWeight="semibold" color="neutral.700" textAlign="left" whiteSpace="nowrap" className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Text" data-sentry-source-file="BrandSection.tsx">
              {relatedCollections?.brand?.name ?? '-'}
            </Text>
            <Text textStyle={{
            base: 'label.small',
            tablet: 'label.medium'
          }} fontWeight="normal" color="neutral.400" textAlign="left" whiteSpace="nowrap" data-sentry-element="Text" data-sentry-source-file="BrandSection.tsx">
              {(relatedCollections?.brand?.count ?? 0).toLocaleString()} Products
            </Text>
          </VStack>
        </HStack>

        {/* View More Button */}
        <Button variant="outline" size="sm" colorScheme="primary" borderColor="primary.600" color="primary.600" borderRadius="8px" paddingX={5} paddingY={2} height="auto" textStyle={{
        base: 'label.small',
        tablet: 'label.medium'
      }} fontWeight="normal" onClick={handleBrandClick} _hover={{
        backgroundColor: 'primary.50'
      }} data-sentry-element="Button" data-sentry-source-file="BrandSection.tsx">
          View More
        </Button>
      </HStack>
    </Box>;
};
export default BrandSection;